import React, { useCallback, useEffect, useState, useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import style from './style/Products.module.css';
import api from '../apis/api';

import Collection from './Collection';
import Card from '../components/Card';
import CardLoader from '../components/CardLoader';


import { userContext } from '../App';

const Products = () => {
    const {dispatch } = useContext(userContext);
    const location = useLocation();
    const [productdata, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    const searchdata = location.state;

    const card = (val, index) => {
        return (
            <Card productName={val.productName} colorOption={val.colorOption} discountAmount={val.discountAmount} amount={val.amount} productImage={val.productImage} size={val.size} index={index} _id={val._id} />
        )
    }
    
    const getProduct = useCallback(async () => {
        setLoader(false)
        let response;
        try {
            if (searchdata === 'Saree' || searchdata === 'Jeans' || searchdata === 'Skirt' || searchdata === 'Top') {
                response = await api.post('/category', { query: searchdata });
            } else if (searchdata === 'All Products') {
                response = await api.get('/products');
            } else if (searchdata === null) {
                response = await api.get('/products');
            } else {
                response = await api.post('/searchquery', { query: searchdata });
            }
            
            const res = await response.data;
            const data = res.data;
            const status = res.status;
            // console.log(res.status);
            if(status){
                dispatch({type:"USER",payload:true});
            }else{
                dispatch({type:"USER",payload:false});
            }
            const newArr = data.slice(0).reverse().map((val) => { return val });
            setData(newArr);
            setLoader(true);
        } catch (error) {
            console.log(error);
        }
       
    }, [searchdata,dispatch]);

    useEffect(() => {
        getProduct();
    }, [getProduct])

    return (
        <>
            <section className={style.body}>
                <div className={style.filter}>
                    <h1 style={{ textAlign: 'center', color:'darkblue' }}>Categories</h1>
                    <Collection />
                </div>
                <div className={style.container}>
                    <h1 style={{ textAlign: 'center', color: 'darkblue', fontSize: '2rem' }}>
                        {
                            loader ? (searchdata === null ? <span>All Products</span> : (productdata.length === 0 ? <><span>No data available for {searchdata} </span> <br/> <NavLink to='/products' > Back to Home </NavLink> </>: <span>Result for {searchdata}</span>)) : <span></span>
                        }
                    </h1>
                    <div className={style.grid}>
                        {loader ? productdata.map((val, index) => {
                            return card(val, index);
                        }) : <CardLoader/>}
                    </div>
                </div>

            </section>
        </>
    )
}

export default Products;
